/**
 * EmployeeAssignmentDialog Component
 * Dialog for assigning/unassigning employees to a booking
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Checkbox } from '@/components/ui/checkbox';

export default function EmployeeAssignmentDialog({
  open,
  onOpenChange,
  booking,
  employees,
  assignedEmployeeIds = [],
  onAssign,
  onUnassign
}) {
  const isAssigned = (employeeId) => {
    return assignedEmployeeIds.includes(employeeId);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border border-border max-w-2xl" data-testid="assign-employees-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-foreground">
            Assign Employees to Event
          </DialogTitle>
          <p className="text-sm text-muted-foreground mt-2">
            {booking?.client_name} - {booking?.event_date}
          </p>
        </DialogHeader>
        <div className="space-y-4 mt-4 max-h-[60vh] overflow-y-auto">
          {employees.length === 0 ? (
            <p className="text-center text-muted-foreground py-8">
              No employees available. Add employees first.
            </p>
          ) : (
            employees.map((employee) => {
              const assigned = isAssigned(employee.id);
              return (
                <div
                  key={employee.id}
                  className="flex items-center justify-between p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors"
                  data-testid={`employee-assign-item-${employee.id}`}
                >
                  <div className="flex items-center gap-3">
                    <Checkbox
                      checked={assigned}
                      onCheckedChange={(checked) => {
                        if (checked) {
                          onAssign(employee.id);
                        } else {
                          onUnassign(employee.id);
                        }
                      }}
                      data-testid={`employee-checkbox-${employee.id}`}
                    />
                    <div>
                      <div className="font-medium text-foreground">{employee.name}</div>
                      <div className="text-sm text-muted-foreground">{employee.role}</div>
                      {employee.skills && employee.skills.length > 0 && (
                        <div className="flex gap-1 mt-1">
                          {employee.skills.slice(0, 3).map((skill, idx) => (
                            <span key={idx} className="text-xs bg-primary/20 text-primary px-2 py-0.5 rounded">
                              {skill}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  {employee.hourly_rate && (
                    <div className="text-sm text-muted-foreground">
                      ${employee.hourly_rate}/hr
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
